import { render, staticRenderFns } from "./ChurchsInputComponent.vue?vue&type=template&id=860b14ae&scoped=true&"
import script from "./ChurchsInputComponent.vue?vue&type=script&lang=js&"
export * from "./ChurchsInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChurchsInputComponent.vue?vue&type=style&index=0&id=860b14ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b14ae",
  null
  
)

export default component.exports